import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import cssInject from './vars-inject';
import { capitalize } from './strings';
import { entries } from './objects';

function setOptions(options, setter) {
  if (!options) return;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = entries(options)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          _value = _step$value[1];

      if (key === setter) continue;
      this[key] = _value;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function getDOMStyle(dom) {
  document.body.appendChild(dom);
  var style = window.getComputedStyle(dom);
  Promise.resolve().then(function () {
    if (dom.parentElement) dom.parentElement.removeChild(dom);
  });
  return style;
}

function getStyleAttr(className) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'color';
  var div = document.createElement('div');
  div.className = className;
  return getDOMStyle(div)[key];
}

var cache = {};

function genAccessors(obj, data) {
  data.conf.forEach(function (item) {
    var name = item.name,
        className = item.className,
        attr = item.attr,
        _item$parser = item.parser,
        parser = _item$parser === void 0 ? function (v) {
      return v;
    } : _item$parser;
    var info = data.info;
    var cacheKey = "".concat(info.name, "-").concat(name);
    Object.defineProperty(obj, name, {
      enumerable: true,
      get: function get() {
        if (cache[cacheKey]) return cache[cacheKey];
        if (item.value) return item.value;
        var res = getStyleAttr(className, attr);
        cache[cacheKey] = parser(res);
        return cache[cacheKey];
      },
      // eslint-disable-next-line no-return-assign
      set: function set(v) {
        delete cache[cacheKey];
        if (item.value) item.value = v;
        data[name] = v;
      }
    });
  });
}

var accessors = Object.keys(cssInject).reduce(function (obj, key) {
  return _objectSpread2(_objectSpread2({}, obj), {}, _defineProperty({}, key, {}));
}, {});
var _iteratorNormalCompletion2 = true;
var _didIteratorError2 = false;
var _iteratorError2 = undefined;

try {
  var _loop = function _loop() {
    var _step2$value = _slicedToArray(_step2.value, 2),
        key = _step2$value[0],
        value = _step2$value[1];

    var setterName = "set".concat(capitalize(key));

    value[setterName] = function (options) {
      return setOptions.call(value, options, setterName);
    };

    genAccessors(value, cssInject[key]);
  };

  for (var _iterator2 = entries(accessors)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
    _loop();
  }
} catch (err) {
  _didIteratorError2 = true;
  _iteratorError2 = err;
} finally {
  try {
    if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
      _iterator2["return"]();
    }
  } finally {
    if (_didIteratorError2) {
      throw _iteratorError2;
    }
  }
}

export function cleanCache() {
  cache = {};
}
export default accessors;